var React = require('react');

function PolygonWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M107.839 26.9645L123.233 159.927L0.386973 106.777L107.839 26.9645Z","fill":"white"}));
}

PolygonWhite.defaultProps = {"width":"170","height":"160","viewBox":"0 0 170 160","fill":"none"};

module.exports = PolygonWhite;

PolygonWhite.default = PolygonWhite;
